import { Injectable } from '@angular/core';
import { Mutation, gql } from 'apollo-angular';



@Injectable({
  providedIn: 'root'
})
export class CreateCatalogGQL extends Mutation<CreateCatalogGQLResponse, CreateCatalogGQLVariables> {
  document = gql`
    mutation createCatalog($name: String!) {
      createCatalog(data: { name: $name }) {
        catalogId
      }
    }
  `;
}

interface CreateCatalogGQLVariables {
  name: string;
}

interface CreateCatalogGQLResponse {
  createCatalog: {
    catalogId: string;
  };
}
